import moment from "moment";
import { toast } from "react-toastify";

export class DateTool {
  static calculateMonthsBetween(startDate, endDate) {
    const start = moment(startDate);
    const end = moment(endDate);
    return end.diff(start, "months", true);
  }

  static requestDurationFormat(requestDurationMs) {
    let formattedDuration = "";
    const seconds = Math.floor(requestDurationMs / 1000);
    formattedDuration += seconds > 0 ? `${seconds}seg, e ` : "";
    formattedDuration += `${requestDurationMs % 1000}ms`;
    return formattedDuration;
  }

  static format(dateStr, locale = "br") {
    const date = new Date(dateStr.replace(" ", "T"));
    if (isNaN(date) || !dateStr) {
      toast.error("Error ao formatar data");
      return "";
    }

    const locales = {
      br: "pt-BR",
      us: "en-US",
    };

    return date.toLocaleString(locales[locale] || "en-US", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    });
  }

  static addDays(date, days, businessDays = false) {
    let result = moment(date);
    if (!businessDays) {
      return result.add(days, "days");
    } else {
      let added = 0;
      while (added < days) {
        result = result.add(1, "days");
        if (result.day() !== 0 && result.day() !== 6) {
          added++;
        }
      }
      return result;
    }
  }
}
